module.exports = __webpack_public_path__ + "static/media/listing-icon.b096fedd.svg";